import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-statistics-sales-graph',
  templateUrl: './statistics-sales-graph.component.html',
  styleUrls: ['./statistics-sales-graph.component.scss'],
})
export class StatisticsSalesGraphComponent implements OnInit {
  public isLoaded: boolean = false;
  chartOptions: any;

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.loadLastSales();
  }

  loadLastSales(): void {
    this.isLoaded = true;

    forkJoin({
      lastYearSales: this.getLastYearSales(),
      lastYearReceivedSales: this.getLastYearReceivedSales(),
      lastYearWithdrawSales: this.getLastYearWithdrawSales(),
    }).subscribe({
      next: (results) => {
        const lastYearSales = results.lastYearSales;
        const lastYearReceivedSales = results.lastYearReceivedSales;
        const lastYearWithdrawSales = results.lastYearWithdrawSales;

        this.loadMonthGraph(
          lastYearReceivedSales.labels,
          lastYearWithdrawSales.values,
          lastYearSales.values,
          lastYearReceivedSales.values
        );
      },
      error: (error) => {
        console.error('Erro ao carregar os saldos', error);
      },
      complete: () => {
        this.isLoaded = false;
      },
    });
  }

  getLastYearSales() {
    return this.dashBoardService.getLastYearSales().then((value) => {
      return value;
    });
  }

  getLastYearReceivedSales() {
    return this.dashBoardService.getLastYearReceivedSales().then((value) => {
      return value;
    });
  }

  getLastYearWithdrawSales() {
    return this.dashBoardService.getLastYearWithdrawSales().then((value) => {
      return value;
    });
  }

  loadMonthGraph(
    labels: string[],
    lastYearWithdrawSales: number[],
    lastYearSales: number[],
    lastYearReceivedSales: number[]
  ) {
    this.chartOptions = {
      series: [
        {
          name: 'Saques',
          type: 'bar',
          data: lastYearWithdrawSales,
        },
        {
          name: 'Depósitos gerados',
          type: 'area',
          data: lastYearSales,
        },
        {
          name: 'Depósitos recebidos',
          type: 'line',
          data: lastYearReceivedSales,
        },
      ],
      colors: ['#0CC7E0', '#266cd4', '#e5f5ff'],
      chart: {
        height: 350,
        type: 'bar',
      },

      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 3,
      },
      plotOptions: {
        bar: {
          columnWidth: '15%',
        },
      },
      yaxis: {
        labels: {
          formatter: function (y: number) {
            return Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
            }).format(y);
          },
        },
      },
      xaxis: {
        categories: labels,
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (y: number) {
            return Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
            }).format(y);
          },
        },
      },
      grid: {
        show: false,
      },
    };
  }
}
